// src/chartConfig.js
import { 
  Chart as ChartJS,
  CategoryScale,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  LineController,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LinearScale
} from 'chart.js';

// Registra os componentes do Chart.js que vamos usar na aplicação.
// Ao importar este ficheiro no ponto de entrada da aplicação (main.jsx),
// garantimos que esta configuração é executada uma única vez.

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  BarElement,
  LineElement,
  PointElement,
  BarController,
  LineController,
  LinearScale,
  Title
);